<template>
  <div class="panel-controls">
    <div class="left">
      <button type="button" @click="showEvents">Events</button> <strong>&</strong><br>
      <button type="button" @click="showContact">Contact</button>
    </div>
    <div class="right">
      <button type="button" @click="showArchive">Archive</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showEvents() {
      this.$store.commit('setPanelVisibleLeft', true)
      this.$store.commit('setPanelContentLeft', 'events')
    },
    showContact() {
      this.$store.commit('setPanelVisibleLeft', true)
      this.$store.commit('setPanelContentLeft', 'contact')
    },
    showArchive() {
      this.$store.commit('setPanelVisibleRight', true)
    }
  }
}
</script>
